import { Observable, of, switchMap } from 'rxjs';
import { mobileNavItemsFilter } from '../../utils';
import { WindowService } from '@app/shared/services';
import { HeaderItem } from '../../model/header.model';
import { NavMenuItem } from '../models/nav-menu-item';
import { AdminItem } from '../../modules/nav-item-admin/components/nav-item-admin-list/models';

export const menuItemsFilter = <T extends (AdminItem | NavMenuItem | HeaderItem)[]>({
    windowService,
    isVeryLargeFontSize$,
}: {
    windowService: WindowService;
    isVeryLargeFontSize$: Observable<boolean>;
}) =>
    switchMap((items: T) => {
        return isVeryLargeFontSize$.pipe(
            switchMap((isVeryLargeFontSize) => {
                if (isVeryLargeFontSize) {
                    return of(items);
                }

                return of(items).pipe(mobileNavItemsFilter(windowService));
            }),
        );
    });
